import React from 'react'
const mission = require('../assets/new_mission.png')
const vision = require('../assets/Vision_Vector_resized.png')

const CardComponent = () => {
    return (
        <div className="container">
                <div className="row padd-topbtm-25">
                    <div className="card col-md-5 col-sm-12 card-padd card-1">
                        <img src={vision} width='307' height="207" className="card-img-top img-fluid" alt="Vision" style={{ borderRadius: '20px' }} />
                        <div className="card-body text-justify">
                            <h5 className="card-title">Our <span className="font-bold-700">Vision</span></h5>
                            <p className="card-text">We Believe that Art is an activator of innovations. At BEE Hives, we converge product Design Solutions along with cognitive training to significantly bring out the best in everyone we touch, <span className="font-bold">Because Art Matters !</span></p>
                            <p>"A vision that Drives Our Passion for Excellence"</p>
                        </div>
                    </div>
                    <div className="col-2"></div>
                    <div className="card col-md-5 col-sm-12 card-padd card-margin-top card-2">
                        <img src={mission} width="307" height="270" className="card-img-top img-fluid" alt="Mission" style={{ borderRadius: '20px' }} />
                        <div className="card-body text-justify">
                            <h5 className="card-title">Our <span className="font-bold-700">Mission</span></h5>
                            <p className="card-text">Our Mission is to devote ourselves with ardour to the service we provide. To train and create an optimistic team who improves and works incessantly towards the betterment of the future.</p>
                        </div>
                    </div>
                </div>
            </div>
    )
}
// img-fluid .. for img resp
export default CardComponent